import { defineStore } from 'pinia'

import mitt from 'mitt'
import { Emitter, EventType } from 'mitt'

type ClevverEventMap = {
  requestFailed: { message: string }
  requestSuccess: { message: string }
}

export const clevverEmitter = mitt<ClevverEventMap>()

export const useEventStore = defineStore('event.store', {
  actions: {
    emitRequestFailed(message: string) {
      clevverEmitter.emit('requestFailed', { message })
    }
  }
})